import MainContent from '../MainContent';
import Header from '../Header/Header';

// REACT LOADING SKELETON
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function PageSkeleton() {
  const skeletonColor = '#e4e4e4';
	const ersteBlue = '#2870ED';
	const ersteLightBlue = '#578ff0';
  return (
    <>
      <Header cssClasses="header--default header--withimage">
				<Skeleton baseColor={ersteBlue} highlightColor={ersteLightBlue} className="header__image" />			
      </Header>

			<MainContent cssClasses="w-desktop--center">
				<div className="mt-300rem mb-100rem">
					<Skeleton baseColor={skeletonColor} width={'80%'} height={30} />
				</div>
				<Skeleton baseColor={skeletonColor} width={150} height={15} />
				<Skeleton baseColor={skeletonColor} width={'50%'} height={15} />

				<div className="lh-160 mt-200rem">
					<Skeleton count={5} baseColor={skeletonColor} height={20} />
				</div>
			</MainContent>

    </>
  );
}

export default PageSkeleton;
